export const ELang = Object.freeze({
  English: 'en',
  French: 'fr-FR',
  Russian: 'ru-RU',
  German: 'de-DE',
  Spanish: 'es-ES',
  Portuguese: 'pt-BR',
});

export type ELang = (typeof ELang)[keyof typeof ELang];
